export const FETCH_PRICE_FACTORS_GROUPS_REQUEST = '@@toyota/FETCH_PRICE_FACTORS_GROUPS_REQUEST';
export const FETCH_PRICE_FACTORS_GROUPS_FAILED = '@@toyota/FETCH_PRICE_FACTORS_GROUPS_FAILED';
export const FETCH_PRICE_FACTORS_GROUPS_SUCCESS = '@@toyota/FETCH_PRICE_FACTORS_GROUPS_SUCCESS';

export const FETCH_PRICE_FACTORS_PRODUCT_CODES_REQUEST = '@@toyota/FETCH_PRICE_FACTORS_PRODUCT_CODES_REQUEST';
export const FETCH_PRICE_FACTORS_PRODUCT_CODES_FAILED = '@@toyota/FETCH_PRICE_FACTORS_PRODUCT_CODES_FAILED';
export const FETCH_PRICE_FACTORS_PRODUCT_CODES_SUCCESS = '@@toyota/FETCH_PRICE_FACTORS_PRODUCT_CODES_SUCCESS';

export const GET_PRICE_FACTORS_INFO_REQUEST = '@@toyota/GET_PRICE_FACTORS_INFO_REQUEST';
export const GET_PRICE_FACTORS_INFO_FAILED = '@@toyota/GET_PRICE_FACTORS_INFO_FAILED';
export const GET_PRICE_FACTORS_INFO_SUCCESS = '@@toyota/GET_PRICE_FACTORS_INFO_SUCCESS';

export const CLEAR_PRICE_FACTORS_LIST = '@@toyota/CLEAR_PRICE_FACTORS_LIST';

export const CHANGE_PRICE_FACTORS_PAGE = '@@toyota/CHANGE_PRICE_FACTORS_PAGE';
export const CHANGE_PRICE_FACTORS_PAGE_SIZE = '@@toyota/CHANGE_PRICE_FACTORS_PAGE_SIZE';

export const SAVE_PRICE_FACTORS_REQUEST = '@@toyota/SAVE_PRICE_FACTORS_REQUEST';
export const SAVE_PRICE_FACTORS_FAILED = '@@toyota/SAVE_PRICE_FACTORS_FAILED';
export const SAVE_PRICE_FACTORS_SUCCESS = '@@toyota/SAVE_PRICE_FACTORS_SUCCESS';

export const DOWNLOAD_PRICE_FACTOR_LIST_REQUEST = '@@toyota/DOWNLOAD_PRICE_FACTOR_LIST_REQUEST';
export const DOWNLOAD_PRICE_FACTOR_LIST_SUCCESS = '@@toyota/DOWNLOAD_PRICE_FACTOR_LIST_SUCCESS';
export const DOWNLOAD_PRICE_FACTOR_LIST_FAILED = '@@toyota/DOWNLOAD_PRICE_FACTOR_LIST_FAILED';

export const CLEAR_PRICE_FACTORS_LIST_URL = '@@toyota/CLEAR_PRICE_FACTORS_LIST_URL';

export const UPSERT_PRICE_FACTOR_REQUEST = '@@toyota/UPSERT_PRICE_FACTOR_REQUEST';
export const UPSERT_PRICE_FACTOR_FAILED = '@@toyota/UPSERT_PRICE_FACTOR_FAILED';
export const UPSERT_PRICE_FACTOR_SUCCESS = '@@toyota/UPSERT_PRICE_FACTOR_SUCCESS';
